import { useState, useEffect } from 'react';

import TextInput from '../inputs/TextInput';
import Button from '../inputs/Button';
import { incrementNameNoConflicts } from '../../utils';
import useAudienceNameValidation from '../../hooks/useAudienceNameValidation';

export default function AudienceNameForm({
  onBlur,
  onSubmit,
  initialValue,
  canSave,
  hasStateChanged,
  isSavedAudience,
  setNameError,
}) {
  const [value, setValue] = useState(initialValue);

  const { audienceWithNameAlreadyExists, takenNames } =
    useAudienceNameValidation(value);

  useEffect(() => {
    if (
      initialValue &&
      audienceWithNameAlreadyExists &&
      takenNames &&
      initialValue === value &&
      !isSavedAudience
    ) {
      const incrementedName = incrementNameNoConflicts(
        initialValue,
        takenNames
      );
      if (typeof onBlur === 'function') {
        setValue(incrementedName);
        onBlur(incrementedName);
      }
    }
  }, [
    audienceWithNameAlreadyExists,
    initialValue,
    isSavedAudience,
    onBlur,
    takenNames,
    value,
  ]);

  function handleSubmit(e) {
    e.preventDefault();

    if (audienceWithNameAlreadyExists && !isSavedAudience) {
      setNameError(true);
      return;
    }

    if (canSave) {
      onSubmit(value);
    }
    setNameError(false);
  }

  useEffect(() => {
    if (typeof initialValue === 'string') {
      setValue(initialValue);
    }
  }, [initialValue]);

  return (
    <form className="flex flex-row space-x-3" onSubmit={handleSubmit}>
      <TextInput
        type="text"
        value={value}
        onChange={(e) => {
          const { value } = e.target;
          setValue(value);
        }}
        onBlur={() => onBlur(value)}
        placeholder="Untitled Audience"
        disabled={isSavedAudience}
      />
      <Button
        type="submit"
        disabled={!canSave}
        primary={canSave && hasStateChanged}
        secondary={canSave && !hasStateChanged}
      >
        Save audience
      </Button>
    </form>
  );
}
